import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setTestResults } from "../../repository/slice";

function* getTestResultsWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/statistic/quiz/" + payload.id);
        if (isError) {

        } else {
            yield put(setTestResults(data));
        }
    } catch (error) {
        console.error("getTestResultsWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getTestResultsWatcher() {
    yield takeLatest("@saga/GET_TEST_RESULTS", getTestResultsWorker);
};